import { render, staticRenderFns } from "./table-ordering.vue?vue&type=template&id=40f69f32&scoped=true&"
import script from "./table-ordering.vue?vue&type=script&lang=js&"
export * from "./table-ordering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f69f32",
  null
  
)

export default component.exports